<style lang="scss" scoped>
.login {
  height: 100%;
  overflow: auto;
  background-repeat: no-repeat;
  position: relative;
  // background-size: 100% 100%;
  background-size: cover;
  background-position: center;
}

.login-logo-icon {
  position: fixed;
  top: 60px;
  left: 80px;
  width: 199px;
  height: 50px;
  display: flex;
  align-items: center;
  background: url('~@/static/projectImg/login/logo.png') center center no-repeat;
  background-size: contain;
}

.login-form {
  width: 400px;
  position: absolute;
  top: 50%;
  right: 6%;
  transform: translateY(-50%);
  margin-bottom: 32px;
}

/* 移动端适配 */
@media screen and (max-width: 800px) {
  .login-form {
    position: relative;
    top: 0;
    right: 0;
    transform: none;
    width: 90%;
    max-width: 400px;
    margin: 40px auto;
    // padding: 40px 0;
    .lls-card{
      padding: 20px 0 !important;
    }
  }
  .login {
    flex-direction: column;
    justify-content: flex-start;
    min-height: 100vh;
    background-size: cover;
    background-position: left top;
  }
  .login-logo-icon {
    display: none;
  }
  ::v-deep .lls-input__suffix {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .lls-input__inner {
    height: 32px;
    border-radius: 10px;
    line-height: 32px;
  }
  ::v-deep .lls-form-item__label {
    font-size: 12px;
    margin-bottom: 0;
  }
  ::v-deep .lls-card.is-always-shadow, 
  ::v-deep .lls-card.is-hover-shadow:focus, 
  ::v-deep .lls-card.is-hover-shadow:hover {
    box-shadow: 0px 14px 42px 0px rgba(37,100,253,0.08)
  }
}

.logo {
  width: 100px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 20px;
}

.label {
  color: #000000;
}

.verification {
  position: absolute;
  right: 0px;
  width: 68px;
  height: 32px;
  border-left: 1px solid #eee;
  cursor: pointer;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  color: #3e8cfa;
}

.verification-sent {
  display: inline-block;
  text-align: center;
  line-height: 30px;
  height: 30px;
  border-radius: 0 8px 8px 0;
  font-size: 12px;
  width: 80px;
  border-left: 1px solid #e2e2e2;
  box-sizing: border-box;
}

.login-btn {
  width: 100%;
  height: 32px;
  font-size: 14px;
  color: #ffffff;
  border-radius: 16px;
  margin: 10px 0 26px 0;

  &.is-disabled {
    color: #fff;
    background: #c8c9cc;
    border-color: #c8c9cc;
    &:hover {
      color: #fff;
      background: #c8c9cc;
      border-color: #c8c9cc;
    }
  }
}

.logo-box-text {
  color: #000000;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 30px;
}
.login-text-rigister {
  // margin-top: 16px;
  .no-account {
    color: #6b778c;
    font-size: 12px;
    cursor: pointer;
  }
}

.box-forget {
  color: #6b778c;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
}
.forgetBtn {
  position: absolute;
  right: 26px;
  z-index: 1;
}
.hight-light {
  color: #3e8cfa;
  font-size: 12px;
  cursor: pointer;
}

.login-bottom-text {
  position: fixed;
  bottom: 8px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #777575;
}

.err-text {
  height: auto;
  color: #f56c6c;
  font-size: 12px;
  margin-bottom: 22px;
}

.agree-consent {
  margin-bottom: 4px;
  font-size: 12px;
  display: flex;
  color: #000000;

  .my-agree {
    margin-left: 5px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .agreeLink {
      cursor: pointer;
      color: #3e8cfa;
      font-size: 12px;
      margin: 0 2px;
    }
  }
}

::v-deep .el-loading-mask {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;

  .el-loading-spinner {
    margin-top: -15px;

    .circular {
      height: 22px;
      width: 22px;
    }
  }
}

.lls-button {
  padding: 5px 20px;
  border: 1px solid rgba(90, 156, 248, 0.5);
}

.lls-button:hover {
  background-image: linear-gradient(rgb(90, 156, 248), rgb(144, 190, 253));
}

::v-deep .lls-form-item__content {
  line-height: 10px;
}

::v-deep .lls-form-item__label {
  margin-bottom: 2px;
  color: #000000 !important;
  line-height: 22px;
}

.enlarge {
  width: 205px;
}
</style>

<template>
  <div class="login" :style="{ backgroundImage: 'url(' + getDispositionMap.backgroundImage + ')' }">
    <div class="login-logo-icon"></div>
    <div class="login-form">
      <lls-card class="box-card" style="padding: 41px 5px;">
        <div class="logo-box">
          <!-- <img
            :src="logo"
            alt
            v-if="!getDispositionMap.isChangeDisposition"
            :class="{ logo: true, enlarge: customer === 'volofin' }"
          /> -->
        </div>
        <template v-if="!forgetShow && !isRegitser">
          <!-- ========================================= 重置密码 ========================================= -->
          <template v-if="reSetPwd">
            <div class="logo-box-text">{{ $t('login.resetPassword') }}</div>
            <lls-form
              :model="ReSetruleForm"
              :status-icon="false"
              :rules="ReSetruleFormrules"
              ref="ReSetruleForm"
              class="demo-ruleForm"
              hide-required-asterisk
              :validate-on-rule-change="false"
            >
              <!-- 密码 -->
              <lls-form-item prop="pass" :label="$t('login.password')" ref="pass">
                <pswValidatePopover>
                  <lls-input
                    show-password
                    v-model="ReSetruleForm.pass"
                    autocomplete="off"
                    :placeholder="$t('login.password')"
                    @focus="clearMsgErr('pass')"
                  ></lls-input>
                </pswValidatePopover>
              </lls-form-item>
              <!--      <el-form-item prop="pass" label="覆盖第二个框对应的密码反显问题" v-show="false">
                                                <el-input show-password autocomplete="off" placeholder="第二密码"></el-input>
              </el-form-item>-->
              <!-- 确认密码 -->
              <lls-form-item
                prop="checkPass"
                :label="$t('login.confirmNewPassword')"
                ref="checkPass"
              >
                <lls-input
                  type="password"
                  show-password
                  v-model="ReSetruleForm.checkPass"
                  autocomplete="off"
                  :placeholder="$t('login.confirmNewPassword')"
                  @focus="clearMsgErr('checkPass')"
                ></lls-input>
              </lls-form-item>
            </lls-form>
            <div class="err-text" :title="msgErr">{{ msgErr }}</div>
            <!-- 重置 -->
            <lls-button
              class="login-btn"
              style="text-align: center"
              type="primary"
              :disabled="!resetFormValidate"
              @click.stop="ResubmitForm('ReSetruleForm')"
            >{{ $t('login.resetPassword') }}</lls-button>
            <!-- 返回 -->
            <lls-button
              class="login-btn"
              style="text-align: center; margin-left: 0px"
              type="primary"
              @click.stop="cancleRe('ReSetruleForm')"
            >{{ $t('login.return') }}</lls-button>
          </template>
          <!-- ========================================= OTP ========================================= -->
          <OTP v-else-if="showOTP" @cancel="handleCancel" @confirm="handleOTPConfirm"></OTP>
          <!-- ========================================= 登录 ========================================= -->
          <template v-else>
            <div class="logo-title" style="display: flex;justify-content: space-between;">
              <div class="logo-box-text">{{ $t('login.loginTitle') }}</div>
              <div>
                <!-- 登录-切换语言 -->
                <lls-dropdown @command="changeLang">
                  <span class="box-forget">
                    {{ langString
                    }}
                    <i
                      class="lls-icon-arrow-down lls-icon--right"
                    ></i>
                  </span>
                  <lls-dropdown-menu slot="dropdown">
                    <lls-dropdown-item command="zh">简体中文</lls-dropdown-item>
                    <lls-dropdown-item command="en">English</lls-dropdown-item>
                  </lls-dropdown-menu>
                </lls-dropdown>
              </div>
            </div>
            <lls-form
              :model="ruleForm"
              :status-icon="false"
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
              hide-required-asterisk
              :validate-on-rule-change="false"
            >
              <!-- 账号 -->
              <lls-form-item prop="pass" :label="$t('login.account')" ref="pass">
                <lls-input
                  type="text"
                  v-model="ruleForm.pass"
                  autocomplete="off"
                  :placeholder="$t('login.account')"
                  @focus="clearMsgErr('pass')"
                ></lls-input>
              </lls-form-item>
              <!-- 密码 -->
              <div class="forgetBtn hight-light" @click="ForgetPwd">{{ $t('login.forgetPassword') }}</div>
              <lls-form-item prop="checkPass" :label="$t('login.password')" ref="checkPass">
                <lls-input
                  show-password
                  v-model="ruleForm.checkPass"
                  autocomplete="off"
                  :placeholder="$t('login.password')"
                  @focus="clearMsgErr('checkPass')"
                ></lls-input>
              </lls-form-item>
              <!-- 验证码 -->
              <lls-form-item
                prop="age"
                class="test"
                :label="$t('login.verificationCode')"
                ref="age"
              >
                <lls-input
                  v-model="ruleForm.age"
                  :placeholder="$t('login.verificationCode')"
                  @focus="clearMsgErr('age')"
                ></lls-input>
                <img :src="imgSrc" alt @click="refreshimg" class="verification" />
              </lls-form-item>
            </lls-form>
            <div class="err-text">{{ msgErr }}</div>
            
            <lls-button
              class="login-btn"
              style="text-align: center"
              type="primary"
              :loading="loading"
              @click.stop="submitForm('ruleForm')"
              :disabled="!isCheckBoxAgree"
            >
              {{ $t('login.login') }}
              <!--<el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>-->
            </lls-button>
            <div class="agree-consent">
              <lls-checkbox v-model="isCheckBoxAgree" class="agreeCheckBox"></lls-checkbox>
              <div class="my-agree">
                <span>{{ $t('login.agree') }}</span>
                <lls-link @click="handleUrl" class="agreeLink">{{ $t('login.userAgreement') }}</lls-link>
                {{ $t('login.and') }}
                <lls-link @click="handlePolicyUrl" class="agreeLink">{{ $t('login.privacyPolicy') }}</lls-link>
              </div>
            </div>
            <div class="login-text-rigister" @click="switchRegister">
              <span class="no-account">{{ $t('login.noAccount') }}</span>
              <span class="hight-light">{{ $t('login.registerNow') }}</span>
            </div>
          </template>
        </template>
        <!-- ========================================= 忘记密码 ========================================= -->
        <template v-if="forgetShow">
          <div class="logo-box-text">{{ $t('login.forgetPwd') }}</div>
          <lls-form
            :model="ForgetruleForm"
            :status-icon="false"
            :rules="ForgetruleFormrules"
            ref="ForgetruleForm"
            class="demo-ruleForm"
            hide-required-asterisk
            :validate-on-rule-change="false"
          >
            <!-- 新密码 -->
            <lls-form-item prop="pass" :label="$t('login.newPassword')" ref="pass">
              <pswValidatePopover>
                <lls-input
                  show-password
                  v-model="ForgetruleForm.pass"
                  autocomplete="off"
                  :placeholder="$t('login.newPassword')"
                  @focus="clearMsgErr('pass')"
                ></lls-input>
              </pswValidatePopover>
            </lls-form-item>
            <!--  <el-form-item prop="pass" label="覆盖第二个框对应的密码反显问题" v-show="false">
                                <el-input show-password autocomplete="off" placeholder="第二密码"></el-input>
            </el-form-item>-->
            <!-- 确认密码 -->
            <lls-form-item prop="checkPass" :label="$t('login.confirmNewPassword')" ref="checkPass">
              <lls-input
                show-password
                v-model="ForgetruleForm.checkPass"
                autocomplete="off"
                :placeholder="$t('login.confirmNewPassword')"
                @focus="clearMsgErr('checkPass')"
              ></lls-input>
            </lls-form-item>
            <!-- 邮箱 -->
            <lls-form-item prop="email" :label="$t('login.email')" ref="email">
              <lls-input
                v-model="ForgetruleForm.email"
                autocomplete="off"
                :placeholder="$t('login.email')"
                @focus="clearMsgErr('email')"
              ></lls-input>
            </lls-form-item>
            <!-- 验证码 -->
            <lls-form-item prop="phoneCode" :label="$t('login.verificationCode')" ref="phoneCode">
              <lls-input
                v-model="ForgetruleForm.phoneCode"
                autocomplete="off"
                :placeholder="$t('login.verificationCode')"
                @focus="clearMsgErr('phoneCode')"
              ></lls-input>
              <!-- 发送验证码 -->
              <div
                @click="getVerificationCode"
                element-loading-spinner="lls-icon-loading"
                v-loading="sentding"
                class="verification verification-sent"
              >{{ count > 0 ? count + 's' : $t('login.sendCode') }}</div>
            </lls-form-item>
          </lls-form>
          <div class="err-text" :title="msgErr">{{ msgErr }}</div>
          <!-- 重置 -->
          <lls-button
            type="primary"
            class="login-btn"
            style="text-align: center; margin-bottom: 10px"
            @click.stop="ResubmitForm('ForgetruleForm')"
            :disabled="!forgetFormValidate"
          >{{ $t('login.resetPassword') }}</lls-button>
          <!-- 返回 -->
          <lls-button
            type="primary"
            class="login-btn"
            style="text-align: center; margin-bottom: 0px; margin-left: 0px"
            @click.stop="cancleRe('ForgetruleForm')"
          >{{ $t('login.return') }}</lls-button>
        </template>
        <template v-if="isRegitser">
          <Register @switch="switchRegister" @view="handleUrl" @handlePolicyUrl="handlePolicyUrl"></Register>
        </template>
      </lls-card>
    </div>
    <div class="login-bottom-text">
      <span>{{ getDispositionMap.recordInformation }}</span>
    </div>
    <template v-if="agreementShow">
      <serviceGreementDialog
        :show="agreementShow"
        :pdfUrl="pdfUrl"
        @close="closePdf"
        @sure="sureSign"
      ></serviceGreementDialog>
    </template>
  </div>
</template>

<script>
// import serviceGreementDialog from '@/components/serviceGreementDialog/index.vue'
import pswValidatePopover from '@/components/pswValidatePopover/index.vue'
import { testPortalPassword } from '@/utils/portalPasswordRules'
import { syncTradeRoleAfterSetOrg } from '@/utils/tradeRole'
import Register from '@/components/Register.vue'
import OTP from './OTP.vue'
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios';
export default {
  name: 'loginSSO',
  components: {
    pswValidatePopover,
    OTP,
    Register,
    // serviceGreementDialog
  },
  directives: {
    test: {
      bind(el, binding, vnode) {
        console.log('%c bind', 'color: red')
        console.log(el, binding, vnode)
      },
    },
  },
  data() {
    return {
      contractTypeDz: null, // 电子债务凭证类型
      mediaId: '', // 传给电子债务凭证签署页面的值
      ruleForm: {
        pass: '',
        checkPass: '',
        age: '',
      },
      ReSetruleForm: {
        pass: '',
        checkPass: '',
      },
      ForgetruleForm: {
        pass: '',
        checkPass: '',
        email: '',
        phoneCode: '',
      },
      imgSrc: '',
      show: false,
      reSetPwd: false, //重置密码

      msgErr: '',
      tokenUuid: '',
      username: '',
      agreementShow: false, //协议显示
      pdfUrl: '',
      sysChannel: 'kj_my_pc',
      forgetShow: false,
      timer: null,
      isDisabled: false,
      count: 0,
      sentding: false,
      currentComp: {}, //选择的企业
      loginErrCode: '',
      langString: this.$i18n.locale == 'zh' ? '简体中文' : 'English',
      loading: false,
      customer: '',
      logoMap: {
        DEFAULT: require('@/static/projImg/logoNew.svg'),
        volofin: require('@/static/projImg/logo-volofin.svg'),
      },
      isCheckBoxAgree: true, //同意协议才能登录
      showOTP: false,
      // 注册
      isRegitser: false,
    }
  },
  computed: {
    ...mapGetters(['getDispositionMap']),
    rules() {
      const rules = {
        pass: [
          {
            required: true,
            message: this.$t('login.PleaseEnterUsername'),
            trigger: 'submit',
          },
        ],
        checkPass: [
          {
            required: true,
            message: this.$t('login.pleaseEnterPassword'),
            trigger: 'submit',
          },
        ],
        age: [
          {
            required: true,
            message: this.$t('login.pleaseEnterVerification'),
            trigger: 'submit',
          },
        ],
      }
      this.$nextTick(() => {
        this.$refs['ruleForm'].fields.forEach((item) => {
          if (item.validateState === 'error') {
            this.$refs['ruleForm'].validateField(item.prop)
          }
        })
      })
      return rules
    },
    ForgetruleFormrules() {
      var validatePass3 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('login.pleaseReenterPassword')))
        } else if (value !== this.ForgetruleForm.pass) {
          callback(new Error(this.$t('login.pswNotSame')))
        } else {
          callback()
        }
      }
      const ForgetruleFormrules = {
        pass: [
          {
            required: true,
            message: this.$t('login.pleaseEnterNewPassword'),
            trigger: ['submit'],
          },
        ],
        checkPass: [
          {
            required: true,
            validator: validatePass3,
            trigger: ['blur', 'change'],
          },
        ],
        email: [
          {
            required: true,
            message: this.$t('login.pleaseEnterEmail'),
            trigger: ['submit'],
          },
        ],
        phoneCode: [
          {
            required: true,
            message: this.$t('login.pleaseEnterVerification'),
            trigger: ['submit'],
          },
        ],
      }
      return ForgetruleFormrules
    },
    forgetFormValidate() {
      const formIsNotEmpty =
        this.ForgetruleForm.pass !== '' &&
        this.ForgetruleForm.checkPass !== '' &&
        this.ForgetruleForm.email !== '' &&
        this.ForgetruleForm.phoneCode !== ''
      const formValidate = this.pswValidate(this.ForgetruleForm.pass)
      const twoPass = this.ForgetruleForm.pass === this.ForgetruleForm.checkPass
      return formIsNotEmpty && formValidate && twoPass
    },
    resetFormValidate() {
      const formIsNotEmpty =
        this.ReSetruleForm.pass !== '' && this.ReSetruleForm.checkPass !== ''
      const formValidate = this.pswValidate(this.ReSetruleForm.pass)
      const twoPass = this.ReSetruleForm.pass === this.ReSetruleForm.checkPass
      return formIsNotEmpty && formValidate && twoPass
    },
    ReSetruleFormrules() {
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          // 请再次输入密码
          callback(new Error(this.$t('login.pleaseReenterPassword')))
        } else if (value !== this.ReSetruleForm.pass) {
          // 两次输入密码不一致
          callback(new Error(this.$t('login.pswNotSame')))
        } else {
          callback()
        }
      }
      const ReSetruleFormrules = {
        pass: [
          {
            required: true,
            message: this.$t('login.pleaseEnterPassword'),
            trigger: 'submit',
          },
        ],
        checkPass: [{ validator: validatePass2, trigger: ['blur', 'change'] }],
      }
      return ReSetruleFormrules
    },
    logo() {
      const res = this.logoMap[this.customer]
      return res
    },
  },
  async created() {
    await this.getCustomization()
  },
  async mounted() {
    // 判断 query 中 action ==='register'
    if (this.$route.query.action === 'register') {
      this.switchRegister() // 切换到注册页
      await this.$sso.logout()
      localStorage.clear()
    }

    sessionStorage.clear()
    const query = this.$route.query
    if (query.refer) {
      this.customer = query.refer.toLowerCase()
    } else {
      this.customer = 'DEFAULT'
    }
    //判断参数国际化参数
    let urlLang = this.$route.query.lang || this.$i18n.locale
    if (urlLang == 'EN' || urlLang == 'En' || urlLang == 'en') {
      //英文环境
      this.changeLang('en')
    } else {
      //默认中文环境
      this.changeLang('zh')
    }
    await this.checkLogin()
    await this.refreshimg()
    this.ruleForm.pass = this.$route.query.userName || ''
    //绑定事件，其他界面可能要写在methods里
    window.addEventListener('keydown', this.keyDown)
    //清除上次缓存的刷新页面
    sessionStorage.removeItem('flashPath')
    sessionStorage.removeItem('flashPathName')
  },

  // mounted:function(){
  //     sessionStorage.clear()
  //     this.refreshimg()
  //     this.ruleForm.pass = this.$route.query.userName || ''
  // },
  methods: {
    ...mapActions(['getCustomization']),
    handleOTPConfirm() {
      this.loginSuccess()
    },
    pswValidate(psw) {
      return testPortalPassword(psw)
    },
    handleUrl() {
      const res = `${window.location.protocol}//${window.location.host}/#/terms`
      window.open(res, '_blank')
    },
    handlePolicyUrl() {
      const hostname = window.location.hostname;
      let baseUrl;
      
      if (hostname.includes('hrlyit')) {
        baseUrl = 'https://unloqx.hrlyit.com';
      } else if (hostname.includes('qhhrly')) {
        baseUrl = 'https://unloqx.qhhrly.cn';
      } else {
        baseUrl = 'https://www.unloq.com';
      }
      
      const lang = this.$i18n.locale === 'zh' ? 'CN' : 'EN';
      const policyUrl = `${baseUrl}/policy?LANG=${lang}`;
      
      window.open(policyUrl, '_blank');
    },
    //最终选择企业进入
    async chooseFinal(table) {
      //判断该企业有无菜单，无菜单没有权限
      let curLoginName = sessionStorage.getItem('curLoginName')
      const powerFlag = await this.$API.enterprise.getMenuByEnterpriseId({
        sysChannel: 'kj_my',
        enterpriseId: table.id,
        loginName: curLoginName,
      })
      if (!powerFlag) return
      console.log('choose finally:', this.loaidng)
      sessionStorage.setItem('enterpriseId', table.id)
      try {
        localStorage.setItem('enterpriseId', table.id)
      } catch (e) {}
      document.cookie = 'llskjorg=' + table.id + ';path=/;'
      sessionStorage.setItem('companyIdentCode', table.companyIdentCode)
      sessionStorage.setItem('companyName', table.companyName)
      sessionStorage.setItem('enterpriseRole', table.enterpriseRole)

      let _this = this
      let status = JSON.parse(table.status).dictParam //ENDURANCE  审核通过
      try {
        const data = await _this.$http.get(
          `/kj-web/sys/setOrgId?orgId=${table.id}`
        )
        await syncTradeRoleAfterSetOrg(_this.$http)

        const queryObj = await _this.$http.get(
          `/kj-kyc/product/listByEnterpriseIdByClient`
        )
        let productTypeArr = queryObj.data.data || []
        _this.$store.commit('user/updateState', {
          key: 'listByEnterpriseId', // dyy 所有的企业id？
          value: productTypeArr,
        })
        console.log('productTypeArr666', productTypeArr)
        //国际结算特殊处理
        let calcCompany = productTypeArr.filter((item) => {
          let productType = this.filterJSONString(item.productType)
          return productType == 'PURCHASE_PAYMENT'
        })
        if (calcCompany && calcCompany.length > 0) {
          //存在国际结算产品
          if (calcCompany.length == productTypeArr.length) {
            //有且只有一个国际计算产品
            sessionStorage.setItem('IS_ONLY_PURCHASE_PAYMENT', true)
          } else {
            sessionStorage.setItem('IS_ONLY_PURCHASE_PAYMENT', false)
          }
        } else {
          sessionStorage.setItem('IS_ONLY_PURCHASE_PAYMENT', false)
        }

        let productTypeObj = productTypeArr[0] || {}
        var productType = productTypeObj.productType
          ? JSON.parse(productTypeObj.productType).dictParam
          : ''
        sessionStorage.setItem('enterpriseProductType', productType)
        var code = data.data.code || ''

        if (code == '200') {
          // 后端判定是否需要跳转
          const link = await this.goRedirect()
          if (link) {
            location.href = link
            return
          }
          const { productType: queryProductType } = this.$route.query
          if (queryProductType === 'E_FINANCE') {
            this.$router.push({
              path: '/AdvanceCredit',
              query: { productType: queryProductType },
            })
            return
          }
          // _this.$store.state.currentCompany = table status: 企业状态
          if (status == 'ENDURANCE') {
            console.log(11)
            //审核通过
            // dyy 只有一个企业的时候判断是否需要签署电子
            this.$http
              .post(`/kj-contract/contractInfo/getDigipoServiceContractClient`)
              .then((res) => {
                if (res.data.code == '200') {
                  if (res.data.data) {
                    this.mediaId = res.data.data.mediaId
                    this.contractTypeDz = this.filterJSONString(
                      res.data.data.contractType
                    )
                    this.$router.push({
                      path: '/contract',
                      query: {
                        mediaId: this.mediaId,
                        contractTypeDz: this.contractTypeDz,
                      },
                    })
                  } else {
                    const query = this.$route.query
                    // _this.$router.push({ path: '/bigHome', query })
                    _this.$router.push({ path: '/home', query })
                  }
                } else {
                  this.$message({
                    message: res.data.message,
                    type: 'error',
                  })
                }
              })
          } else if (status == 'INIT' && productType == 'E_FINANCE') {
            console.log(22)
            //待完善 产品类型为电商融资
            _this.$router.push({
              path: '/childEkycPortal/efinKyc',
              query: { id: table.id, status: status },
            })
          } else if (status == 'BACK' && productType == 'E_FINANCE') {
            console.log(33)
            //审核退回 产品类型为电商融资
            _this.$router.push({
              path: '/childEkycPortal/efinKyc',
              query: { id: table.id, status: status },
            })
          } else if (status == 'SUBMIT' && productType == 'E_FINANCE') {
            console.log(44)
            //建档审核中 产品类型为电商融资
            _this.$router.push({
              path: '/childEkycPortal/efinKyc',
              query: { id: table.id, status: status },
            })
          } else if (
            ['INIT', 'BACK', 'SUBMIT'].includes(status) &&
            productType == 'DIGIPO'
          ) {
            _this.$router.push({
              path: '/childEkycPortal/efinKyc',
              query: { id: table.id, status: status },
            })
          } else if (status == 'INIT' && productType == 'IDD') {
            console.log(55)
            //待完善 产品类型为IDD
            _this.$router.push({
              path: '/kycFileCN',
              query: { id: table.id, status: status },
            })
          } else if (status == 'BACK' && productType == 'IDD') {
            console.log(66)
            //审核退回 产品类型为IDD
            _this.$router.push({
              path: '/kycFileCN',
              query: { id: table.id, status: status },
            })
          } else if (status == 'SUBMIT' && productType == 'IDD') {
            console.log(77)
            //建档审核中 产品类型为IDD
            _this.$router.push({
              path: '/kycFileCN',
              query: { id: table.id, status: status },
            })
          } else if (['DEFAULT_PRODUCT', 'ACCOUNT'].includes(productType)) {
            // 自注册会新增 DEFAULT_PRODUCT，直接进入home，会跳转至产品中心
            _this.$router.push({ path: '/home', query: this.$route.query })
          } else {
            console.log(88)
            // '建档状态异常，请联系管理员'
            _this.$alert(
              _this.$t('login.onboardingStatusAbnormal'),
              _this.$t('login.tips'),
              {
                confirmButtonText: _this.$t('login.confirm'),
              }
            )
          }
        } else {
          // $.fn.mAlert('body',{tips:data.body.msg});
          _this.$alert(data.body.message, _this.$t('login.tips'), {
            confirmButtonText: _this.$t('login.confirm'),
          })
        }
      } catch (response) {
        // $.fn.mAlert('body',{tips:response});
        _this.$alert(response, _this.$t('login.tips'), {
          confirmButtonText: _this.$t('login.confirm'),
        })
      }
    },
    //获取平台协议
    async getAgm() {
      // console.log("get agm:", this.loading)
      let _this = this
      // this.loading = true;
      let data = null
      try {
        data = await _this.$http.post(
          `/kj-contract/contractInfo/getPlatformServiceContractClient`
        )
        console.log('get agm:', this.loading)
        if (data.data.code == 200) {
          if (!data.data.data) {
            //如果没有返回时也就是不用签署
            //不需要签署
            return false
          }
          let signObj = data.data.data || {}
          let contractStatus = _this.filterJSONString(signObj.contractStatus)
          if (contractStatus == 'WAIT_SIGN') {
            //未签署
            //判断是否为买方 + 境内 - 2021-05-25去除需求
            // if(signObj.enterpriseRole == 0 && signObj.enterpriseLocation == 0){
            //     this.$alert('您如需签署平台服务协议，请联系运营人员协助处理，谢谢。', '提示', {
            //         confirmButtonText: '确定',
            //         callback: action => {
            //
            //         }
            //     });
            //     return true
            // }else {
            //     this.agreementShow = true
            //     this.pdfUrl = signObj.url
            //     // this.pdfUrl = '/static/sss.pdf'
            //     return true
            // }
            // _this.agreementShow = true
            // _this.pdfUrl = signObj.accessPath
            // _this.contractId = signObj.id
            // this.pdfUrl = '/static/sss.pdf'
            return false
          } else {
            //不需要签署
            return false
          }
        } else {
          return true
        }
      } catch (response) {
        return true
      }
    },
    //选择一个企业
    async chooseOne(table) {
      console.log('choose one')

      //判断是否有签署平台协议
      this.currentComp = table || {}
      //已经签署
      await this.chooseFinal(table)
    },
    //获取企业
    async getCompList() {
      let _this = this
      //   this.loading = true;
      console.log('loading:', this.loading)
      try {
        // const data = await _this.$http.post('/kj-web/sys/getEnterpriseVO')
        const data = await _this.$http.post(
          '/kj-sys/kjEnterprise/getEnterpriseByType',
          {
            productType: [
              'IDD',
              'DOC_EXCHANGE',
              'PURCHASE_PAYMENT',
              'E_FINANCE',
              'MARKET',
              'DIGIPO',
              'EXPORT_DRAWBACK_PROD',
              'EXPORT_DRAWBACK_TRADE',
              'DEFAULT_PRODUCT',
              'ACCOUNT',
            ],
          }
        )
        var code = data.data.code
        if (code == '200') {
          // _this.$router.push('/login');
          let tl = data.data.data || []
          // 内管端有且只有一个企业
          // tl.map(item=>{
          //     this.userName = item.entCnName || ''
          // })

          if (tl.length > 1) {
            const query = this.$route.query
            console.log(query)
            let copyQuery = { ...query, aaa: false }

            console.log('888', 2, copyQuery)

            _this.$router.push({ path: '/companyChoose', query })
          } else {
            if (tl.length == 1) {
              //只有一个企业
              //再判断是否需要签署
              await _this.chooseOne(tl[0])
            } else {
              // 您暂无企业，请联系运营人员协助处理，谢谢
              _this.$alert(
                _this.$t('login.noCompanyFoundContact'),
                _this.$t('login.tips'),
                {
                  confirmButtonText: _this.$t('login.confirm'),
                }
              )
            }
          }
        } else {
          // $.fn.mAlert('body',{tips:data.body.msg});
          _this.$alert(data.body.message, _this.$t('login.tips'), {
            confirmButtonText: _this.$t('login.confirm'),
          })
        }
      } catch (response) {
        // $.fn.mAlert('body',{tips:response});
        _this.$alert(response, _this.$t('login.tips'), {
          confirmButtonText: _this.$t('login.confirm'),
        })
      } finally {
        // this.loading = false;
      }
    },
    //修改语言
    changeLang(lang) {
      // debugger
      console.log(lang, '=====')
      console.log('this.changeLang', lang)
      localStorage.setItem('locale', lang)
      this.$i18n.locale = lang // dyy 通过切换locale的值来实现语言切换
      if (lang == 'zh') {
        this.langString = '简体中文'
      } else {
        this.langString = 'English'
      }
      //通知子应用更新
      this.$setGlobalState({ langlocale: lang })
    },

    //绑定监听事件
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        if (!this.reSetPwd && !this.forgetShow) {
          this.submitForm('ruleForm')
        }
      }
    },
    getVerificationCode() {
      if (this.count > 0) {
        return
      } else {
        let _this = this
        let email = this.ForgetruleForm.email
        if (!email) {
          // 请输入邮箱
          this.msgErr = this.$t('login.pleaseEnterEmail')
          return
        }
        if (_this.sentding) return
        _this.sentding = true
        _this.$http
          .get(`/kj-sys/setting/sendForgetPwdCodeForDigipo?email=${email}`)
          .then(
            function (data) {
              _this.sentding = false
              // 验证码已发送，请查收
              _this.$message({
                message: _this.$t('login.verificationSentInbox'),
                type: 'success',
              })
              _this.countDown()
            },
            function (response) {
              _this.sentding = false
            }
          )
      }
    },
    countDown() {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.isDisabled = true
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.isDisabled = false
            clearInterval(this.timer)
            this.timer = null
            console.log(this.count, '=========')
          }
        }, 1000)
      }
    },
    //================================SSO=============================
    async checkLogin() {
      console.log(this.$sso, '=======')
      // setTimeout(async()=>{
      //     await this.$sso.checkLogin()
      // },0)
      try {
        setTimeout(async () => {
          var res = await this.$sso.checkLogin()
          if (res) {
            const { data: OTPobj } = await this.$http.post(
              '/kj-sys/kjEnterprise/getIsOTPByType',
              {
                productType: [
                  'IDD',
                  'DOC_EXCHANGE',
                  'PURCHASE_PAYMENT',
                  'E_FINANCE',
                  'MARKET',
                  'DIGIPO',
                  'EXPORT_DRAWBACK_PROD',
                  'EXPORT_DRAWBACK_TRADE',
                  'DEFAULT_PRODUCT',
                  'ACCOUNT',
                ],
              }
            )
            if (!OTPobj.data) {
              this.getCompList()
            }
          }
        }, 0)
      } catch (e) {
        //e.message 是一个JSON，格式：'{"code":"10901","message":"账号或密码错误"}'
        console.log('自动登录checkLogin', e)
        var obj = JSON.parse(e.message)
      }
    },
    async doLogin() {
      this.loading = true
      try {
        let data = await this.$sso.doLogin({
          ifRemember: false, //是否记住
          loginName: this.ruleForm.pass, //用户账号*
          password: this.ruleForm.checkPass, //用户密码*
          imgCode: this.ruleForm.age, //图形验证码*
          encrypt: true, //是否加密，暂时可以不加密，过段时间宽哥会强制加密
          sysChannel: this.sysChannel, //所属系统*
        })
        if (data.code == '200') {
          if (data.switchCode && data.switchCode == '30900') {
            //新用户请初始化密码 ;
            this.$message({
              message: this.$t('login.pleaseResetPassword'),
              type: 'success',
            })
            this.reSetPwd = true
          } else {
            sessionStorage.setItem('curLoginName', this.ruleForm.pass)
            // 判断otp
            const { data: OTPobj } = await this.$http.post(
              '/kj-sys/kjEnterprise/getIsOTPByType',
              {
                productType: [
                  'IDD',
                  'DOC_EXCHANGE',
                  'PURCHASE_PAYMENT',
                  'E_FINANCE',
                  'MARKET',
                  'DIGIPO',
                  'EXPORT_DRAWBACK_PROD',
                  'EXPORT_DRAWBACK_TRADE',
                  'DEFAULT_PRODUCT',
                  'ACCOUNT',
                ],
              }
            )
            if (OTPobj.data) {
              this.showOTP = true
            } else {
              
              
              this.loginSuccess();
            }
          }
        }
      } catch (error) {
        // console.log(error.message, '=======错误信息======')
        // var err = JSON.parse(error.message)
        // this.refreshimg()
        // if (err.code == '30903') {
        //   //密码已过期，请修改密码
        //   this.$message.error(err.message)
        //   this.reSetPwd = true
        //   this.loginErrCode = err.code
        // }
        // this.msgErr = err.message
        // 错误提示
        this.showError(error)
      } finally {
        this.loading = false
      }
    },
    showError(error) {
      console.log(error, '=======错误信息======')
      this.refreshimg()
      try {
        let err;
        // 尝试解析 error.message（如果是 JSON）
        if (typeof error.message === 'string') {
          err = JSON.parse(error.message); // 可能是后端返回的 JSON 错误
        } else {
          // 如果 error.message 不是字符串（如 Axios 错误对象）
          err = {
            code: error.response?.status || 'UNKNOWN',
            message: error.response?.data?.message || 'Service Unavailable',
          };
        }

        // 处理特定错误码
        if (err.code === '30903') {
          this.$message.error(err.message); // 密码过期
          this.reSetPwd = true;
          this.loginErrCode = err.code;
        } else if (err.code === 503 || !err.message || err.message === '') {
          // 处理 503 或其他无消息的错误
          this.$message.error(this.$t('login.serviceUnavailable') || '服务暂时不可用，请稍后再试');
        } else {
          // 其他错误
          this.$message.error(err.message);
        }
        this.msgErr = err?.message || ''; // 存储错误信息
      } catch (e) {
        this.$message.error(this.$t('login.serviceUnavailable') || '服务暂时不可用，请稍后再试');
        this.msgErr = '';
      }
    },
    // 后端返回跳转链接，预授信返回预授信链接，否则返回空
    goRedirect () {
      const { productType, scenario } = this.$route.query;
      // 调用接口，处理重定向
      const params = { productType, scenario };
      return new Promise((resolve, reject) => {
        try{
          this.$http.get('/kj-official/potentialCust/redirect', { params }).then(({data}) => {
            if (data.code == 200 && data.data) {
              const location = data.data
              // 本地调试预授信场景切换成下方代码
              // const location = 'http://localhost:8888/#/AdvanceCredit?productType=E_FINANCE&scenario=AMAZON_SC'
              resolve(location);
            } else {
              resolve();
            }
          })
        } catch (error) {
          resolve();
        }
      })
    },
    //======================================================
    loginSuccess() {
      this.getCompList()
    },
    closePdf() {
      this.agreementShow = false //协议显示
      this.pdfUrl = ''
    },
    //确认签署
    sureSign() {
      let _this = this
      _this.$http.post(`/kj-idd/home/signPlatformAgreement`).then(
        function (data) {
          _this.$router.push('/home')
        },
        function (response) {}
      )
    },
    // //获取协议
    // async getAgm(){
    //     let _this = this
    //     let result = await _this.$http.post(
    //         `/kj-idd/home/queryPlatformAgreementSignStatus`,
    //     ).then(function(data){
    //         let url = data.data.url || ''
    //         if(!url){
    //             return false
    //         }else{
    //             //需要签署
    //             _this.agreementShow = true
    //             _this.pdfUrl = url
    //             return true
    //         }

    //     },function(response){
    //         return true
    //     })
    //     return result
    // },
    cancleRe(formName) {
      this.$refs[formName].resetFields()
      if (formName.includes('ForgetruleForm')) {
        this.forgetShow = false
      } else {
        this.reSetPwd = false
        this.loginErrCode = ''
      }
      this.msgErr = ''
    },
    clearMsgErr(formName) {
      this.msgErr = ''
      if (typeof formName == 'string') {
        this.$refs[formName].clearValidate()
      }
    },
    async refreshimg() {
      this.imgSrc = await this.$sso.captchaImage({
        sysChannel: this.sysChannel,
      })
    },
    async forgetPwdSSO() {
      let _this = this
      //验证验证码
      // ForgetruleForm:{
      //     pass: '',
      //         checkPass: '',
      //         email:'',
      //         phoneCode:'',
      // },
      let code = this.ForgetruleForm.phoneCode
      let email = this.ForgetruleForm.email

      if (this.sentding) return
      this.sentding = true
      try {
        // dyy
        let getPublicKey = ''
        getPublicKey = await this.getPubKey1()
        if (!getPublicKey) {
          return
        }
        var confirmPassword =
          this.encryptedData(this.ForgetruleForm.checkPass, getPublicKey) || ''
        let params = {
          loginName: email,
          password: confirmPassword,
          phoneCode: code,
          sysChannel: this.sysChannel,

          confirmPassword,
          encrypt: true,
          sysChannel: this.sysChannel, //所属系统* dyy
        }
        _this.$http
          .post('/sso-web/opera/forgetPasswdForDigipo', params)
          .then((res) => {
            this.sentding = false
            if (res.data.code == '200') {
              // 密码重置成功，请重新登录
              this.$message({
                message: this.$t('login.passwordResetLogin'),
                type: 'success',
              })
              // this.$router.replace('/login')
              this.cancleRe('ForgetruleForm')
              this.refreshimg()
            }
          })
          .catch((error) => {
            _this.sentding = false
          })
      } catch (error) {
        _this.sentding = false
        let err = JSON.parse(error.message).message
        // this.$message.error(err)
        // 暂无响应，请联系管理员
        this.msgErr = err || _this.$t('login.serverNotRsponding')
      }
      // this.$http.get(
      //     `/kj-sys/setting/verifyForgetPwdCode?code=${code}&email=${email}`,{handingResponseErrMsg:true}
      // ).then(async data=>{
      //     if(data.data.code == 200){

      //     }
      // },err=>{
      //     this.sentding =false
      //     this.msgErr = err
      // })
    },
    ResubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          // this.initPwd()
          if (formName.includes('ForgetruleForm')) {
            this.forgetPwdSSO()
          } else {
            if (this.loginErrCode == '30903') {
              this.resetPasswdSSO()
            } else {
              this.initPwdSSO()
            }
          }

          // this.cancleRe('ReSetruleForm')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    initComp() {
      let _this = this
      _this.$http.post(`kj-kyc/enterpriseContact/updateLoginFlag`, {}).then(
        function (data) {},
        (err) => {}
      )
    },
    //密码过期重新修改
    async resetPasswdSSO() {
      let { sysChannel } = this
      let { pass, checkPass } = this.ReSetruleForm
      let loginName = this.ruleForm.pass
      let orcPassword = this.ruleForm.checkPass
      // let invitationCode = this.ruleForm.checkPass
      let password = pass
      let confirmPassword = checkPass
      try {
        let data = await this.$sso.resetPasswd({
          loginName,
          // invitationCode,
          password,
          confirmPassword,
          sysChannel,
          orcPassword,
        })

        if (data.code == '200') {
          // '密码重置成功，请重新登录'
          this.$message({
            message: this.$t('login.passwordResetLogin'),
            type: 'success',
          })
          // this.$router.replace('/login')
          this.cancleRe('ReSetruleForm')
          this.ruleForm.checkPass = ''
          this.ruleForm.age = ''
          this.refreshimg()
          //首次登录，修改密码后调用一下这个接口
          // this.initComp()
        }
      } catch (error) {
        let err = JSON.parse(error.message).message
        // this.$message.error(err)
        // 暂无响应，请联系管理员
        this.msgErr = err || _this.$t('login.serverNotRsponding')
      }
    },
    //首次登录重置密码
    async initPwdSSO() {
      let { sysChannel } = this
      let { pass, checkPass } = this.ReSetruleForm
      let loginName = this.ruleForm.pass
      let invitationCode = this.ruleForm.checkPass
      let password = pass
      let confirmPassword = checkPass
      try {
        let data = await this.$sso.initPasswd({
          loginName,
          invitationCode,
          password,
          confirmPassword,
          sysChannel,
        })
        if (data.code == '200') {
          // '密码重置成功，请重新登录'
          this.$message({
            message: this.$t('login.passwordResetLogin'),
            type: 'success',
          })
          // this.$router.replace('/login')
          this.cancleRe('ReSetruleForm')
          this.ruleForm.checkPass = ''
          this.ruleForm.age = ''
          this.refreshimg()
          //首次登录，修改密码后调用一下这个接口
          // this.initComp()
        }
      } catch (error) {
        let err = JSON.parse(error.message).message
        // this.$message.error(err)
        // 暂无响应，请联系管理员
        this.msgErr = err || _this.$t('login.serverNotRsponding')
      }
    },
    initPwd() {
      let _this = this
      let password = this.ReSetruleForm.pass
      let confirmPassword = this.ReSetruleForm.checkPass
      _this.$http
        .post(
          `/kj-sso/account/initPwd?confirmPassword=${confirmPassword}&password=${password}&tokenUuid=${_this.tokenUuid}&userName=${_this.username}`,
          {},
          { handingResponseErrMsg: true }
        )
        .then(
          function (data) {
            var code = data.data.code
            if (code == '200') {
              _this.cancleRe('ReSetruleForm')
              _this.ruleForm.checkPass = ''
              _this.ruleForm.age = ''
              _this.refreshimg()
            } else {
              _this.refreshimg()
              // 暂无响应，请联系管理员
              _this.msgErr =
                data.body.msg ||
                data.body.message ||
                _this.$t('login.serverNotRsponding')
            }
          },
          function (response) {
            _this.refreshimg()
            // 暂无响应，请联系管理员
            _this.msgErr = response || _this.$t('login.serverNotRsponding')
          }
        )
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        try {
          //   this.loading = true;
          if (valid) {
            // alert('submit!');
            await this.doLogin() //sso登录
          } else {
            console.log('error submit!!')
            return false
          }
        } catch (e) {
        } finally {
          //   this.loading = false;
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    //获取公钥
    async getPubKey() {
      let _this = this
      let result = ''
      result = await _this.$http.post(`/kj-sso/account/getPublicKey`).then(
        function (data) {
          var code = data.data.code
          if (code == '200') {
            return data.body.data
          } else {
            // _this.$llsAlert({text: data.body.msg || data.body.message});
            _this.msgErr = data.body.msg || data.body.message
            return ''
          }
        },
        function (response) {
          // _this.$llsAlert({text: response});
          _this.msgErr = response
          return ''
        }
      )
      return result
    },

    // 获取确认密码的公钥
    async getPubKey1() {
      let _this = this
      let result = ''
      let email = this.ForgetruleForm.email
      result = await _this.$http
        .post(`sso-web/code/getLoginPublicKey`, {
          loginName: email,
          sysChannel: 'kj_my_pc',
        })
        .then(
          function (data) {
            var code = data.data.code
            if (code == '200') {
              return data.body.data
            } else {
              // _this.$llsAlert({text: data.body.msg || data.body.message});
              _this.msgErr = data.body.msg || data.body.message
              return ''
            }
          },
          function (response) {
            // _this.$llsAlert({text: response});
            _this.msgErr = response
            return ''
          }
        )
      return result
    },
    //加密登录
    async logon(data) {
      let getPublicKey = ''
      getPublicKey = await this.getPubKey()
      if (!getPublicKey) {
        return
      }
      var _this = this
      var userName = this.ruleForm.pass || ''
      var password =
        this.encryptedData(this.ruleForm.checkPass, getPublicKey) || ''
      var picCheckCode = this.ruleForm.age || ''
      _this.username = userName
      // this.$router.push('/home');
      // _this.state = "";
      _this.$http
        .post(`/kj-sso/account/logon`, { userName, password, picCheckCode })
        .then(
          function (data) {
            var code = data.data.code
            if (code == '200') {
              // sessionStorage.setItem("objUser", JSON.stringify(data.data.data))
              // if(window.location.href.includes('localhost')){
              //     document.cookie = "llskj="+data.data.data.sessionId;
              // }
              // _this.$router.push('/home');
              // // _this.getUserInfo()
              let result = data.data.data || {}
              if (!result.tokenUuid) {
                sessionStorage.setItem(
                  'objUser',
                  JSON.stringify(data.data.data)
                )
                if (window.location.href.includes('localhost')) {
                  document.cookie = 'llskj=' + data.data.data.sessionId
                }
                // _this.$router.push('/companyChoose');
                _this.$router.push('/kycFileCN')
                //判断是否需要签署
                // let flag = await _this.getAgm()
                // if(flag){
                //     //需要签署
                // }else {
                //     //已经签署了
                //     _this.$router.push('/home');
                // }

                // _this.getUserInfo()
              } else {
                //存在tokenUuid需要重置密码
                _this.tokenUuid = result.tokenUuid
                _this.reSetPwd = true
              }
            } else {
              _this.refreshimg()
              // 暂无响应，请联系管理员
              _this.msgErr =
                data.body.msg ||
                data.body.message ||
                _this.$t('login.serverNotRsponding')
              // _this.state = "loginFail";
              // _this.$llsAlert({text: data.body.msg || data.body.message});
            }
          },
          function (response) {
            _this.refreshimg()
            // 暂无响应，请联系管理员
            _this.msgErr = response || _this.$t('login.serverNotRsponding')
            // _this.state = "loginFail";
            // _this.$llsAlert({text: response});
          }
        )
    },
    //登录
    login: function (data) {
      var _this = this
      var username = this.ruleForm.pass || ''
      var password = this.ruleForm.checkPass || ''
      var vericode = this.ruleForm.age || ''
      this.username = this.ruleForm.pass
      // this.$router.push('/home');
      // _this.state = "";
      _this.$http
        .post(
          '/kj-sso/account/login?userName=' +
            username +
            '&password=' +
            password +
            '&picCheckCode=' +
            vericode,
          {},
          { handingResponseErrMsg: true }
        )
        .then(
          async function (data) {
            var code = data.data.code
            if (code == '200') {
              // sessionStorage.setItem("objUser", JSON.stringify(data.data.data))
              // if(window.location.href.includes('localhost')){
              //     document.cookie = "llskj="+data.data.data.sessionId;
              // }
              // _this.$router.push('/home');
              // // _this.getUserInfo()
              let result = data.data.data || {}
              if (!result.tokenUuid) {
                sessionStorage.setItem(
                  'objUser',
                  JSON.stringify(data.data.data)
                )
                if (window.location.href.includes('localhost')) {
                  document.cookie = 'llskj=' + data.data.data.sessionId
                }
                console.log('888', 3)
                _this.$router.push('/companyChoose')
                //判断是否需要签署
                // let flag = await _this.getAgm()
                // if(flag){
                //     //需要签署
                // }else {
                //     //已经签署了
                //     _this.$router.push('/home');
                // }

                // _this.getUserInfo()
              } else {
                //存在tokenUuid需要重置密码
                _this.tokenUuid = result.tokenUuid
                _this.reSetPwd = true
              }
            } else {
              _this.refreshimg()
              // 暂无响应，请联系管理员
              _this.msgErr =
                data.body.msg ||
                data.body.message ||
                _this.$t('login.serverNotRsponding')
              // _this.state = "loginFail";
              // _this.$llsAlert({text: data.body.msg || data.body.message});
            }
          },
          function (response) {
            _this.refreshimg()
            // 暂无响应，请联系管理员
            _this.msgErr = response || _this.$t('login.serverNotRsponding')
            // _this.state = "loginFail";
            // _this.$llsAlert({text: response});
          }
        )
    },
    //忘记密码
    ForgetPwd() {
      this.$refs['ruleForm'].resetFields()
      this.forgetShow = true
    },
    handleCancel() {
      this.showOTP = false
    },
    switchRegister() {
      this.isRegitser = !this.isRegitser
    },
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false)
  },
}
</script>
